<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Sửa Khách hàng tiềm năng</h1>
      <div class="btn-group float-right">
        <button
          type="button"
          class="btn font-medium btn-outline-secondary"
          @click="merchantUpdate()"
        >
          <i class="bx bx-user-plus"></i> Cập nhật
        </button>
        <button
          type="button"
          class="btn font-medium btn-outline-secondary"
          @click="checkClosedEdit()"
        >
          <i class="bx bx-exit"></i> Hủy bỏ
        </button>
      </div>
    </div>

    <div v-if="loading" class="card-body p-10 b-t-1-869fb229 text-center">
      <i class="bx bx-loader-circle bx-spin bx-rotate-90 h1"></i>
    </div>

    <div v-else class="card p-10 pt-15 b-t-1-869fb229">
      <ValidationObserver ref="merchantUpdate" class="card-body px-20 mt-2 row">
        <form class="col-md-6">
          <h1 class="form-inner-heading mb-1">Thông tin</h1>

          <div class="form">
            <ValidationProvider
              rules="required|minMaxName_2"
              vid="merchantName"
              name="Tên merchant"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-3 col-form-label"
                  >Tên merchant <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <input
                    v-model="dataEdit.merchantName"
                    type="text"
                    class="form-control"
                    placeholder="Tên merchant"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required" vid="cityCode" name="Tỉnh/Thành phố">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Tỉnh/Thành phố <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <Select2
                    v-model="dataEdit.cityCode"
                    :options="dataProvince"
                    @select="getNameProvince($event)"
                    placeholder="Tỉnh/Thành phố"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <div class="form-group row">
              <label for class="col-sm-3 col-form-label">Quận/huyện</label>
              <div class="col-sm-7">
                <Select2
                  v-model="dataEdit.districtCode"
                  :options="dataDistrict"
                  @select="getNameDistrict($event)"
                  placeholder="Quận/Huyện"
                />
              </div>
            </div>

            <ValidationProvider rules="required" vid="wardCode" name="Phường/Xã">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Phường/Xã <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <Select2
                    v-model="dataEdit.wardCode"
                    :options="dataWard"
                    @select="getNameWard($event)"
                    placeholder="Phường/Xã"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="minMaxName_2" vid="address" name="Địa chỉ">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Địa chỉ </label>
                <div class="col-sm-7">
                  <input
                    v-model="dataEdit.address"
                    type="text"
                    class="form-control"
                    placeholder="Địa chỉ"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="phoneLimit" vid="mobile" name="Số điện thoại">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Số điện thoại <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <input
                    v-model="dataEdit.mobile"
                    type="text"
                    class="form-control"
                    placeholder="Số điện thoại"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="mail_2" vid="email" name="Email">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Email</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataEdit.email"
                    type="text"
                    class="form-control"
                    placeholder="Email"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <div class="form-group row">
              <label class="col-sm-3 col-form-label">Tên biển hiệu</label>
              <div class="col-sm-7">
                <input
                  v-model="dataEdit.storeSignName"
                  type="text"
                  class="form-control"
                  placeholder="Tên biển hiệu"
                />
              </div>
            </div>

            <ValidationProvider rules="minMaxName_2" vid="customerName" name="Tên người đại diện">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-3 col-form-label">Tên người đại diện</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataEdit.customerName"
                    type="text"
                    class="form-control"
                    placeholder="Họ tên"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>

          <div class="form">
            <ValidationProvider rules="required" vid="customerType" name="Loại khách hàng">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-3 col-form-label">Loại hình</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataEdit.customerType"
                    :options="dataCustomerType"
                    placeholder="Loại khách hàng"
                    :class="{
                      'invalid-form':
                        dataEdit.customerType === '' || dataEdit.customerType === null,
                    }"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="mcc" name="Ngành nghề">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Ngành nghề</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataEdit.mcc"
                    :options="systemConfig.businessFields"
                    placeholder="Ngành nghề"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider v-if="dataEdit.mcc" vid="mccDetail" name="Ngành nghề chi tiết">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Ngành nghề chi tiết</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataEdit.mccDetail"
                    :options="getMccDetail(dataEdit.mcc)"
                    placeholder="Ngành nghề chi tiết"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              v-if="dataEdit.mccDetail === 'Khác'"
              vid="numberOfShop"
              name="Ngành nghề chi tiết(Ghi chú thêm)"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Ngành nghề chi tiết(Ghi chú thêm)</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataEdit.mccDetailOther"
                    placeholder="Ngành nghề chi tiết(Ghi chú thêm)"
                    type="text"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="mcc" name="Có GPDKKD không">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Có GPDKKD không</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataEdit.extraInfo.licenseBusiness"
                    :options="systemConfig.licenseBusiness"
                    placeholder="Có GPDKKD không"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>

          <div class="form">
            <ValidationProvider vid="mcc" name="Vị trí cửa hàng">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Vị trí cửa hàng</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataEdit.extraInfo.storeLocation"
                    :options="systemConfig.storeLocation"
                    placeholder="Vị trí cửa hàng"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="mcc" name="Giá trị đơn hàng">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Giá trị đơn hàng</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataEdit.extraInfo.averageOrder"
                    :options="systemConfig.averageOrder"
                    placeholder="Giá trị đơn hàng"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="mcc" name="Người mua hàng">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Người mua hàng</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataEdit.extraInfo.averageAge"
                    :options="systemConfig.averageAge"
                    placeholder="Người mua hàng"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="numberOfShop" name="Số lượng cửa hàng">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Số lượng cửa hàng</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataEdit.extraInfo.numberOfShop"
                    type="number"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="numberOfStaff" name="Số lượng nhân viên">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Số lượng nhân viên</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataEdit.extraInfo.numberOfStaff"
                    type="number"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="cashier" name="Người thu ngân">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Người thu ngân</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataEdit.extraInfo.cashier"
                    :options="systemConfig.cashier"
                    placeholder="Người thu ngân"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="cashier" name="Tình trạng biển hiệu">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Tình trạng biển hiệu</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataEdit.bannerState"
                    :options="systemConfig.bannerState"
                    placeholder="Tình trạng biển hiệu"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>

          <div class="form">
            <ValidationProvider vid="mcc" name="Đã biết MPOS?">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Đã biết MPOS?</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataEdit.extraInfo.knowMPOS"
                    :options="systemConfig.knowMPOS"
                    placeholder="Đã biết MPOS?"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required" vid="suggestServiceList" name="Dịch vụ quan tâm">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Dịch vụ quan tâm<span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <select2-multiple-control
                    v-model="dataEdit.suggestServiceType"
                    :options="systemConfig.services"
                    placeholder="Dịch vụ quan tâm"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="lstPaymentMethodSuggest" name="PT Thanh toán quan tâm">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">PT Thanh toán quan tâm</label>
                <div class="col-sm-7">
                  <select2-multiple-control
                    v-model="dataEdit.extraInfo.lstPaymentMethodSuggest"
                    :options="systemConfig.paymentMethod"
                    placeholder="PT Thanh toán quan tâm"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>
          <div class="form">
            <ValidationProvider vid="mcc" name="Đã có POS">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Đã có POS</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataEdit.extraInfo.ownPOS"
                    :options="systemConfig.ownPOS"
                    placeholder="Đã có POS"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="lstPos" name="POS bên nào">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">POS bên nào</label>
                <div class="col-sm-7">
                  <select2-multiple-control
                    v-model="dataEdit.extraInfo.lstPos"
                    :options="systemConfig.posBank"
                    placeholder="POS bên nào"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              v-if="dataEdit?.extraInfo?.lstPos && dataEdit?.extraInfo?.lstPos?.includes('OTHER')"
              vid="numberOfShop"
              name="POS bên nào(Ghi chú thêm)"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">POS bên nào(Ghi chú thêm)</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataEdit.extraInfo.posOther"
                    placeholder="POS bên nào(Ghi chú thêm)"
                    type="text"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>
          <div class="form">
            <ValidationProvider vid="hasVietQr" name="Đã có VietQR">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Đã có VietQR</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataEdit.extraInfo.hasVietQr"
                    :options="systemConfig.hasVietQr"
                    placeholder="Đã có VietQR"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="lstVietQrBank" name="VietQR bên nào">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">VietQR bên nào</label>
                <div class="col-sm-7">
                  <select2-multiple-control
                    v-model="dataEdit.extraInfo.lstVietQrBank"
                    :options="systemConfig.vietQrBank"
                    placeholder="VietQR bên nào"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              v-if="
                dataEdit?.extraInfo?.lstVietQrBank &&
                dataEdit?.extraInfo?.lstVietQrBank?.includes('OTHER')
              "
              vid="vietQrBankOther"
              name="VietQR bên nào(Ghi chú thêm)"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">VietQR bên nào(Ghi chú thêm)</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataEdit.extraInfo.vietQrBankOther"
                    placeholder="VietQR bên nào(Ghi chú thêm)"
                    type="text"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>
          <div class="form">
            <ValidationProvider vid="hasInstallment" name="Đã có Trả góp">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Đã có Trả góp</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataEdit.extraInfo.hasInstallment"
                    :options="systemConfig.hasInstallment"
                    placeholder="Đã có Trả góp"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="lstInstallmentBank" name="Trả góp bên nào">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Trả góp bên nào</label>
                <div class="col-sm-7">
                  <select2-multiple-control
                    v-model="dataEdit.extraInfo.lstInstallmentBank"
                    :options="systemConfig.installmentBank"
                    placeholder="Trả góp bên nào"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              v-if="
                dataEdit?.extraInfo?.lstInstallmentBank &&
                dataEdit?.extraInfo?.lstInstallmentBank?.includes('OTHER')
              "
              vid="installmentBankOther"
              name="Trả góp bên nào(Ghi chú thêm)"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Trả góp bên nào(Ghi chú thêm)</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataEdit.extraInfo.installmentBankOther"
                    placeholder="Trả góp bên nào(Ghi chú thêm)"
                    type="text"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>
          <div class="form">
            <ValidationProvider vid="softwareUseState" name="Tình trạng dùng PM quản lý">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Tình trạng dùng PM quản lý</label>
                <div class="col-sm-7">
                  <Select2
                    v-model="dataEdit.softwareUseState"
                    :options="systemConfig.softwareUseState"
                    placeholder="Tình trạng dùng PM quản lý"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider vid="storeManagementSoftware" name="PM quản lý cửa hàng">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">PM quản lý cửa hàng</label>
                <div class="col-sm-7">
                  <select2-multiple-control
                    v-model="dataEdit.extraInfo.storeManagementSoftware"
                    :options="systemConfig.storeManagementSoftware"
                    placeholder="PM quản lý cửa hàng"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              v-if="
                dataEdit?.extraInfo?.storeManagementSoftware &&
                dataEdit?.extraInfo?.storeManagementSoftware?.includes('OTHER')
              "
              vid="installmentBankOther"
              name="PM quản lý bên nào(Ghi chú thêm)"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">PM quản lý bên nào(Ghi chú thêm)</label>
                <div class="col-sm-7">
                  <input
                    v-model="dataEdit.extraInfo.storeManagementSoftwareOther"
                    placeholder="PM quản lý bên nào(Ghi chú thêm)"
                    type="text"
                    class="form-control"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>

          <div class="form-group row">
            <label for class="col-sm-3 col-form-label">Ghi chú</label>
            <div class="col-sm-7">
              <input
                v-model="dataEdit.description"
                type="text"
                class="form-control"
                placeholder="Ghi chú"
              />
            </div>
          </div>
        </form>

        <form class="col-md-6">
          <h1 class="form-inner-heading mb-1">Ảnh</h1>
          <div class="form-group row img-list">
            <ul>
              <li v-for="(itemImg, index) in dataUploadImage" :key="index">
                <a href="#popup-slider" data-toggle="modal">
                  <img :src="itemImg" alt="" />
                </a>
              </li>
              <li>
                <div @click="showModalAddImage = true" class="add-img btn">
                  <span class="bx bx-plus text-center"></span>
                </div>
              </li>
            </ul>
          </div>
        </form>
      </ValidationObserver>
    </div>

    <div v-if="showModalNoti">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalNoti = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img :src="srcImage" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messNoti }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="checkToActionModal(keyCheck)"
                    data-dismiss="modal"
                    v-if="keyCheck === 'accept' || keyCheck === 'back'"
                  >
                    Đồng ý
                  </button>
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalNoti = false"
                    data-dismiss="modal"
                    v-if="keyCheck === 'cancel' || keyCheck === 'back'"
                  >
                    Bỏ qua
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <AddImages
      :showModalAddImage="showModalAddImage"
      :dataUploadImage="dataEdit.uploadImages"
      @submitAddImage="addMCImages"
      @close="closeAddImages"
    >
    </AddImages>
  </div>
</template>

<script>
  import merchantMx from '../../mixins/merchantMx'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import getListService from '@/mixins/getDataService'
  import { StaffService } from '@/services/staff.service'
  // import { SalesManagerService } from '@/services/sales-manager.service'
  import Config from '../../thirdParty/config'
  import { MerchantService } from '@/services/merchant.service'
  import { AgentService } from '@/services/agent.service'
  import AddImages from './AssignModal/addImages.vue'

  export default {
    data() {
      return {
        customerId: this.$route.params.customerId,
        dataEdit: {
          suggestServiceType: [],
          extraInfo: {},
        },
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataConfigRegion: [],
        search: {
          limit: 50,
          page: 1,
        },
        loading: false,
        pagination: {
          total: 0,
        },
        messSuccess: '',
        showModalErrCheckTrans: false,
        messErr: '',
        dataContractOrigin: [],
        dataProvince: [],
        dataDistrict: [],
        dataWard: [],
        dataCustomerType: [
          { id: 'COMPANY', text: 'Doanh nghiệp' },
          { id: 'HOUSEHOLD', text: 'Hộ kinh doanh' },
          { id: 'INDIVIDUAL', text: 'Cá nhân' },
        ],
        authInfoList: this.$route.params.auth,
        showModalNoti: false,
        messNoti: '',
        srcImage: '',
        keyCheck: '',
        showModalAddImage: false,
        dataUploadImage: [],
        dataReferSource: Config.sourceCreate,
      }
    },

    mixins: [prepareQueryParamsMixin, getListService, merchantMx],

    async created() {
      this.loading = true
      await this.getProvince()
      await this.getDistictByCode()
      await this.fetchData()
      await this.getWardList(this.dataEdit.cityCode)
      this.getConfigSystem()
      this.loading = false
    },

    components: {
      AddImages,
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
        dataLead: 'leads/getDataLead',
      }),
    },

    methods: {
      async getWardList(cityCode) {
        try {
          this.dataWard = []
          if (!cityCode) {
            this.dataEdit.wardCode = ''
            this.dataEdit.ward = ''
            return
          }

          const response = await StaffService.getWardList({
            cityCode,
          })
          const wardList = Array.isArray(response) ? response : response?.data || []

          this.dataWard =
            wardList?.map(e => ({
              id: e.code,
              text: e.name,
            })) || []
        } catch (error) {
          console.log(error)
        }
      },
      async checkClosedEdit() {
        this.keyCheck = 'back'
        this.showErr('Bạn có chắc chắn muốn huỷ bỏ thao tác không ?')
      },

      async closedEdit() {
        if (this.$route.query.from === 'leads') this.$router.push('/leads')
        else this.$router.push('/potential-customers')
      },

      checkSuggestService() {
        const serviceList = []
        if (
          this.dataEdit.suggestServiceType &&
          this.dataEdit.suggestServiceType.length > 0 &&
          this.dataEdit.suggestServiceType !== null
        ) {
          this.dataEdit.suggestServiceType.map(e => {
            if (e.serviceType && e.serviceType !== null) serviceList.push(e.serviceType)
            // else delete this.dataEdit.suggestServiceType
          })
        }
        this.dataEdit.suggestServiceType =
          serviceList.length !== 0 ? serviceList : this.dataEdit.suggestServiceType
      },

      async getProvince() {
        try {
          const data = await StaffService.getAllCity({})
          if (data.data.length > 0) {
            data.data.forEach(e => {
              this.dataProvince.push({
                id: e.code,
                text: e.name,
              })
            })
          }
        } catch (error) {
          console.log(error)
        }
      },

      async getDistictByCode() {
        try {
          this.dataDistrict = []
          const data = await StaffService.getDistictByCode({})
          if (data.data.length > 0) {
            const dataDistrict = []
            data.data.map(e => {
              dataDistrict.push({ id: e.code, text: e.name })
            })
            this.dataDistrict = dataDistrict
          }
        } catch (error) {}
      },

      getNameProvince(item) {
        this.dataEdit.city = item.text
        this.dataEdit.ward = ''
        this.dataEdit.wardCode = ''
        const provinceCode = item?.id || this.dataEdit.cityCode
        this.getWardList(provinceCode)
      },
      getNameWard(item) {
        this.dataEdit.ward = item.text
      },
      getNameDistrict(item) {
        this.dataEdit.district = item.text
      },

      showErr(message) {
        this.showModalNoti = true
        this.messNoti = message
        this.srcImage = require('@/assets/img/noti-unsuccess2.svg')
      },
      checkToActionModal(keyCheck) {
        if (keyCheck === 'accept' || keyCheck === 'back') {
          this.showModalNoti = false
          this.closedEdit()
        }
        if (keyCheck === 'addLead') {
          this.showModalNoti = false
          this.addLead(true)
        }
      },

      checkServiceList() {
        let check = false
        if (
          this.dataEdit.suggestServiceType.length === 0 ||
          this.dataEdit.suggestServiceType === null
        ) {
          check = true
        }
        if (this.dataEdit.suggestServiceType !== null) {
          this.dataEdit.suggestServiceType.map(e => {
            if (e.serviceType === null) {
              check = true
            }
          })
        }
        return check
      },

      async fetchData() {
        try {
          const response = await MerchantService.merchantDetail({
            customerId: this.customerId,
          })
          const { data } = response
          if (response.code === 1000) {
            this.dataEdit = data
            this.dataUploadImage = data.uploadImages
            this.dataEdit.suggestServiceType = data.listServiceType
            this.checkSuggestService()
            if (this.dataEdit.cityCode && this.dataEdit.cityCode !== '') {
              this.getDistictByCode()
            }
          }
        } catch (error) {
          console.log(error)
        }
      },

      // Cập nhật merchant
      async merchantUpdate() {
        const isSuccess = await this.$refs.merchantUpdate.validate()
        if (!isSuccess) {
          this.keyCheck = 'cancel'
          this.showErr('Vui lòng điền đúng thông tin')
          return
        }
        try {
          this.checkSuggestService()
          const respon = await MerchantService.updateMerchant(this.dataEdit)
          if (respon.code === 1000) {
            this.keyCheck = 'accept'
            this.showModalNoti = true
            this.srcImage = require('@/assets/img/noti-success2.svg')
            this.messNoti = 'Cập nhật thành công'
          } else {
            this.keyCheck = 'cancel'
            this.showErr(respon.message)
          }
        } catch (error) {
          console.log(error)
        }
      },
      // danh sách tỉnh. thành phố
      async getCity() {
        try {
          const data = await StaffService.getAllCity({})
          if (data.data.length > 0) {
            if (this.dataUser.adminLocations.length === 0) {
              data.data.forEach(e => {
                this.dataCitys.push({
                  id: e.code,
                  text: e.name,
                })
              })
              return
            }
            data.data.filter(e => {
              this.dataUser.adminLocations.forEach(element => {
                if (e.code === element) {
                  this.dataCitys.push({
                    id: e.code,
                    text: e.name,
                  })
                }
              })
            })
            return
          }
          this.dataCitys = []
        } catch (error) {
          console.log(error)
        }
      },
      // ds nhóm dịch vụ
      async getServiceList() {
        this.loading = true
        try {
          const data = await AgentService.getServiceList()
          if (data.success) {
            this.dataGroupService = data.data.groupService
            data.data.groupService.map(e => {
              this.groupService.push({ id: e.service, text: e.name })
            })
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },

      addMCImages(dataImage) {
        this.dataEdit.uploadImages = this.dataUploadImage = dataImage
      },

      closeAddImages() {
        this.showModalAddImage = false
        this.dataEdit.uploadImages = this.dataUploadImage
      },
    },
  }
</script>

<style scoped>
  .placeholder {
    background: #f0f0f0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 18px;
    font-family: Helvetica;
  }

  .placeholder:hover {
    background: #e0e0e0;
  }
  .invalid-form {
    border: solid 0.5px #dc3545 !important;
    border-radius: 5px;
  }
  .form {
    border-bottom: 1px solid #bbbbbb;
    margin-bottom: 1rem;
  }
</style>
